export default "__VITE_ASSET__Dn8A8c8O__"